import { QueryFunction, QueryKey } from 'react-query'

import { useAuth } from 'api/providers'

import { useApiQuery, QueryOptions } from './useApiQuery'

/**
 * Supplement useApiQuery with "enabled: isReady":
 * Used to prevent api calls when authorization is not complete.
 */
export function useApiReadyQuery<
  TQueryFnData = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: QueryOptions<TQueryFnData, TData, TQueryKey>,
) {
  const { isReady } = useAuth()
  return useApiQuery(queryKey, queryFn, {
    ...options,
    enabled: isReady,
  })
}
